<template>
  <div class="camera-wrapper">
    <video ref="video" autoplay playsinline class="camera-video"></video>
    <div class="camera-overlay">
      <div class="face-frame"></div>
      <div class="fixed-tips-container">
        <h4 class="tips-title">Dicas para a foto ideal:</h4>
        <ul class="tips-list">
          <li>Centralize o rosto na moldura.</li>
          <li>Mantenha boa iluminação.</li>
          <li>Evite sombras fortes.</li>
          <li>Rosto visível e claro.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CameraCustom',
  data() {
    return {
      stream: null,
    };
  },
  methods: {
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.video.srcObject = this.stream;
        this.$refs.video.onloadedmetadata = () => {
          this.$refs.video.play();
        };
      } catch (err) {
        this.$emit('error', 'Não foi possível acessar a câmera. Verifique as permissões.');
      }
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    },
    capturePhoto() {
      const video = this.$refs.video;
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg');
    },
  },
  beforeDestroy() {
    this.stopCamera();
  },
};
</script>

<style scoped>
.camera-wrapper {
  position: relative;
  width: 100%;
  padding-top: 75%; 
  background-color: black;
  overflow: hidden;
  border-radius: 8px;
}

.camera-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.camera-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  padding: 0;
}

.face-frame {
  width: 40%; 
  height: 0;
  padding-bottom: 55%; 
  border: 3px dashed white;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
}

.fixed-tips-container {
  position: absolute;
  bottom: 10px; 
  left: 10px;   

  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 5px 8px;
  border-radius: 5px;
  font-size: 0.7em;
  text-align: left;
  max-width: 30%; 
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tips-title {
  color: white;
  margin-bottom: 2px;
  font-size: 0.8em;
  font-weight: bold;
}

.tips-list {
  list-style-type: disc;
  padding-left: 12px;
  margin: 0;
  font-size: 0.75em;
}

.tips-list li {
  margin-bottom: 1px;
}
</style>